import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { AwardsService } from '../services';
import { awardsKeys } from '../queryKeys';
import { clampPage } from './useGetCycles';

export const useGetCycleMemberships = (cycleId, filters = {}, page = 1) => {
  const safePage = clampPage(page);

  const { data, error, isError, isPending, isFetching } = useQuery({
    queryKey: awardsKeys.memberships(cycleId, filters, safePage),
    queryFn: () => AwardsService.getCycleMemberships(cycleId, filters, safePage),
    enabled: Boolean(cycleId),
    retry: false,
    placeholderData: keepPreviousData,
  });

  return {
    memberships: data?.items ?? [],
    page: data?.page ?? safePage,
    pageSize: data?.pageSize ?? 15,
    // Reflects the active filters, per the server contract — this is the
    // number the "Total" display shows.
    totalCount: data?.totalCount ?? 0,
    isPending,
    isFetching,
    isError,
    error,
  };
};
